Vue.component('twilio-numbers-table', require('./DirectCallPhone/vue/twilio-numbers-table.vue').default);